export enum CourseCatalogCategoryType {
    UNINITIALIZED = 'uninitialized',
    SUB_CATEGORIES = 'sub_categories',
    OFFERINGS = 'offerings',
}
